export function getOption(inData, outData, lineData) {
  return {
    backgroundColor: 'transparent',
    tooltip: {
      trigger: 'axis'
    },
    title: {
      text: '(数量)',
      textStyle: {
        color: '#B0CCFF',
        fontSize: 14,
        fontWeight: 'normal'
      },
      left: '50',
      top: 30,
    },
    // legend: {
    //   data: [
    //     // {
    //     //     name: '出库',
    //     //     icon: 'rect'
    //     // }, 
    //     {
    //       name: '(数量)',
    //     }
    //   ],
    //   left: '30',
    //   itemGap: 35,
    //   itemHeight: 5,
    //   itemWidth: 20,
    //   top: 10,
    //   textStyle: {
    //     color: '#fff'
    //   }
    // },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },

    xAxis: {
      type: 'category',
      boundaryGap: false,
      axisLine: {
        lineStyle: {
          color: '#B0CCFF',
          opacity: 0.2,
          width: 1, //这里是为了突出显示加上的
        }
      },
      data: lineData,
    },
    yAxis: {
      type: 'value',
      splitLine: {
        lineStyle: {
          // 使用深浅的间隔色
          color: ['#1B3A72']
        }
      },
      axisLine: {
        lineStyle: {
          opacity: 0.2,
          color: '#B0CCFF',
          width: 1, //这里是为了突出显示加上的
        }
      }
    },
    series: [
      // {
      //     name: '出库',
      //     type: 'line',
      //     stack: '总量',
      //     data: outData,
      //     itemStyle: {
      //         color: '#821012'
      //     }
      // },
      {
        name: '(数量)',
        type: 'line',
        stack: '总量',
        data: inData,
        itemStyle: {
          color: '#1941AA'
        }
      }
    ]
  };

}
